import React from 'react';

import Attachments from './Attachments';
import EntityInfo from './EntityInfo';
import OwnerInfo from './OwnerInfo';
import { Applications } from './Applications';
import { BaseGrid, BaseGridItem } from '../../shared/BaseGrid';

export default function MainDashboard({ props }) {
  return (
    <div className="my-4 md:my-8">
      <BaseGrid>
        <BaseGridItem gridConfig="col-span-2 row-span-2">
          <EntityInfo props={props} />
        </BaseGridItem>

        <BaseGridItem gridConfig="col-span-2 row-span-2 row-start-3">
          <OwnerInfo props={props} />
        </BaseGridItem>

        <BaseGridItem gridConfig="col-span-3">
          <Attachments props={props} />
        </BaseGridItem>

        <BaseGridItem gridConfig="col-span-3 row-span-3">
          <Applications props={props} />
        </BaseGridItem>
      </BaseGrid>
    </div>
  );
}
